import { Brush, Clear } from "@mui/icons-material";
import { Button, ClickAwayListener, IconButton, Stack } from "@mui/material";
import PersianSupportTextField from "Global/Components/UnEditableComponents/PersianSupportTextField/PersianSupportTextField";
import { themeColors } from "Global/JsxThemeColor/JsxThemeColor";
import i18next from "i18next";
import React, { useEffect, useMemo, useState } from "react";
import { TwitterPicker } from "react-color";

const HexColorSelector = ({ label, UiValue = null, onChange = () => {} }) => {
  const [openSelector, setOpenSelector] = useState(false);
  const [selectedColor, setSelectedColor] = useState("");
  const HandleOpenSelector = () => {
    setOpenSelector((prev) => !prev);
  };
  useEffect(() => {
    if (openSelector) onChange(selectedColor?.hex);
  }, [selectedColor]);

  const HandleClearColorSelection = () => {
    setSelectedColor("");
    onChange("");
  };
  const memoUiValue = useMemo(() => UiValue, [UiValue]);
  useEffect(() => {
    if (memoUiValue) {
      setSelectedColor({ hex: memoUiValue });
    }
  }, [memoUiValue]);
  return (
    <React.Fragment>
      <ClickAwayListener
        onClickAway={() => {
          setOpenSelector(false);
        }}
      >
        <Stack direction="row-reverse" gap=".3em">
          <Stack flexBasis={"100em"}>
            <PersianSupportTextField
              isSmall={true}
              isEnglish={i18next.language === "en"}
              label={
                selectedColor.length === 0 ? (
                  label
                ) : (
                  <p
                    style={{
                      marginLeft: "2em",
                      backgroundColor: selectedColor.hex,
                      borderRadius: ".2em",
                      textAlign: "center",
                    }}
                  >
                    {selectedColor.hex}
                  </p>
                )
              }
              icon={<Brush />}
              iconFn={HandleOpenSelector}
              disabled={true}
            />
            {openSelector ? (
              <TwitterPicker
                color={selectedColor}
                onChangeComplete={setSelectedColor}
              />
            ) : (
              <></>
            )}
          </Stack>
          <Button
            size="small"
            variant="contained"
            disabled={openSelector}
            onClick={HandleClearColorSelection}
            sx={{
              minWidth: "unset !important",
              color: `${themeColors.ColorPrimary} !important`,
            }}
          >
            <Clear />
          </Button>
        </Stack>
      </ClickAwayListener>
    </React.Fragment>
  );
};

export default HexColorSelector;
